import { ANGLER } from './angler';
import type { SetArt } from './art';
import { ASTRONAUT } from './astronaut';
import { BARNSTORMER } from './barnstormer';
import { BEEKEEPER } from './beekeeper';
import { CHEF } from './chef';
import { CHRONOMANCER } from './chronomancer';
import { CREATOR } from './creator';
import { DISCO } from './disco';
import { GLACIER } from './glacier';
import { GLITCH } from './glitch';
import { GNOME } from './gnome';
import { INFERNO } from './inferno';
import { JESTER } from './jester';
import { KITSUNE } from './kitsune';
import { KNIGHT } from './knight';
import { LUCHADOR } from './luchador';
import { MAGICIAN } from './magician';
import { OOZE } from './ooze';
import { ORIGAMI } from './origami';
import { PIRATE } from './pirate';
import { PLAGUE } from './plague';
import { PUMPKIN } from './pumpkin';
import { REAPER } from './reaper';
import { SHERIFF } from './sheriff';
import { TEMPEST } from './tempest';
import { VOIDWALKER } from './voidwalker';

export type { SetArt } from './art';

/**
 * Every set's art: the Store's first four, the seasons' (ADR-0123: only a pass gives them), the Creator Program's
 * (ADR-0138), then the mythic sets (ADR-0160, each with `flair`).
 */
export const SET_ART = {
  gnome: GNOME,
  beekeeper: BEEKEEPER,
  astronaut: ASTRONAUT,
  pumpkin: PUMPKIN,
  reaper: REAPER,
  creator: CREATOR,
  inferno: INFERNO,
  kitsune: KITSUNE,
  voidwalker: VOIDWALKER,
  tempest: TEMPEST,
  glacier: GLACIER,
  angler: ANGLER,
  jester: JESTER,
  plague: PLAGUE,
  chronomancer: CHRONOMANCER,
  glitch: GLITCH,
  disco: DISCO,
  origami: ORIGAMI,
  ooze: OOZE,
  barnstormer: BARNSTORMER,
  pirate: PIRATE,
  magician: MAGICIAN,
  chef: CHEF,
  knight: KNIGHT,
  sheriff: SHERIFF,
  luchador: LUCHADOR,
} as const satisfies Record<string, SetArt>;
